
/*------------------------------------------------------------------
Helpers
------------------------------------------------------------------*/

const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);

/*------------------------------------------------------------------
Tabbed Content
------------------------------------------------------------------*/


function indexInParent(node) {
    var children = node.parentNode.childNodes;
    var num = 0;
    for (var i = 0; i < children.length; i++) {
        if (children[i] == node) return num;
        if (children[i].nodeType == 1) num++;
    }
    return -1;
}

const updateTabbedContent = (indicator, currentTab) => {
    let rect = currentTab.getBoundingClientRect();
    indicator.style.height = `${rect.height}px`;
    indicator.style.top = `${currentTab.offsetTop}px`;
}

[...queryAll('.js-tabs')].forEach(tabbedContent => {

    let indicator = tabbedContent.querySelector('.js-tabbed-indicator');
    let currentTab = tabbedContent.querySelector('.js-tabs-link.active');
    let currentItem = tabbedContent.querySelector('.js-tabs-item.active');

    [...queryAll('.js-tabs-link', tabbedContent)].forEach(tabbedContentLink => {

        tabbedContentLink.addEventListener('click', (e) => {
            e.preventDefault();
            currentTab.classList.remove('active');
            currentItem.classList.remove('active');
            currentTab = tabbedContentLink;

            currentTab.classList.add('active');

            let tabs = tabbedContent.querySelectorAll('.js-tabs-item');


            currentItem = tabs[indexInParent(currentTab) - 1];
            currentItem.classList.add('active');

            updateTabbedContent(indicator, currentTab);


        });

    });

    updateTabbedContent(indicator, currentTab);

});

